import { OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import Counter from '@/data/models/tables/Counter'

@OrmModel(modelNames.FAILED_SMS_COUNTER)
export default class FailedSmsCounter extends Counter {}
